import React, { useEffect } from 'react';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';

const MembershipPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden bg-[#10091a] px-5 pb-20 pt-32 text-[#fff8e8] sm:px-8 sm:pt-36">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_25%,rgba(117,65,141,0.28),transparent_45%),radial-gradient(ellipse_at_15%_80%,rgba(166,113,47,0.12),transparent_35%)]"
      />
      <section
        aria-labelledby="membership-coming-soon-title"
        className="relative mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center text-center"
      >
        <span className="mb-6 flex h-14 w-14 items-center justify-center rounded-full border border-[#e8c66e]/30 bg-[#1b1025] text-[#e8c66e]">
          <Sparkles className="h-6 w-6" aria-hidden="true" />
        </span>
        <p className="text-[10px] font-semibold uppercase tracking-[0.34em] text-[#e8c66e] sm:text-xs">
          The Wisdom Network · Membership
        </p>
        <h1
          id="membership-coming-soon-title"
          className="mt-5 font-title text-4xl font-medium leading-tight text-[#fff5dc] sm:text-6xl"
        >
          Memberships are coming soon.
        </h1>
        <p className="mt-6 max-w-xl text-sm leading-7 text-[#d8cfe0] sm:text-base">
          Our membership page is being prepared. Please check back soon for updates.
        </p>
        <Link
          to="/"
          className="mt-9 inline-flex min-h-12 items-center gap-2 rounded-lg border border-[#e8c66e]/40 px-5 text-sm font-semibold text-[#fff5dc] transition-colors hover:bg-[#e8c66e]/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#e8c66e]"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden="true" />
          Back to home
        </Link>
      </section>
    </div>
  );
};

export default MembershipPage;
